import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import NotificationBanner from '../../components/ui/NotificationBanner';
import PostCard from '../../components/ui/PostCard';
import { posts } from '../../data/posts';
import resourcesHero from '../../assets/images/hero/resources.jpg';

const Resources = () => {
    return (
        <>
            <Helmet>
                <title>Resources - Nexgen Learning - AI-Driven Education</title>
                <meta name="description" content="Access educational resources, articles, and guides to enhance your learning journey with NexGen Learning." />
            </Helmet>
            <Header />
            <NotificationBanner />
            <main>
                {/* Hero Section with Background Image */}
                <section className="relative pt-40 pb-32">
                    {/* Background Image with Overlay */}
                    <div className="absolute inset-0">
                        <img
                            src={resourcesHero}
                            alt="Resources Background"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/50 to-gray-900/30"></div>
                    </div>

                    {/* Content */}
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center">
                            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 mt-10">
                                Insights & Innovations in Education
                            </h1>
                            <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto">
                                Explore the Latest Trends, Success Stories, and Resources in EdTech and AI
                            </p>
                        </div>
                    </div>
                </section>

                {/* Posts Section */}
                <section className="py-20 bg-gradient-to-b from-white to-gray-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-16">
                            <h1 className="text-5xl py-10 text-primary">|</h1>
                            <h2 className="text-4xl font-bold text-gray-900 mb-6">
                                Popular Posts
                            </h2>
                        </div>

                        {/* Posts Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {posts.map(post => (
                                <PostCard key={post.id} post={post} />
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default Resources;
